module.exports = __webpack_public_path__ + "img/fconnect5.163107c6.png";